

export const UPLOADS_ENDPOINTS = {
  STATUS: { path: "/uploads/status", method: "GET" },
  UPLOAD_IMAGE: { path: "/uploads/image", method: "POST" },
  UPLOAD_IMAGES: { path: "/uploads/images", method: "POST" },
  UPLOAD_FILE: { path: "/uploads/file", method: "POST" },
  UPLOAD_FILES: { path: "/uploads/files", method: "POST" },
  GET_IMAGE: { path: "/uploads/image/:key", method: "GET" },
  GET_FILE: { path: "/uploads/file/:key", method: "GET" },
  DELETE_IMAGE: { path: "/uploads/image/:key", method: "DELETE" },
  DELETE_FILES: { path: "/uploads/files", method: "DELETE" },
  GET_PRESIGNED_URL: { path: "/uploads/presigned-url", method: "POST" },
  GET_PRESIGNED_URLS: { path: "/uploads/presigned-urls", method: "POST" }
};